import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AppConfig from '../../../appConfig';
import classNames from 'classnames';

import BusComponent from '../../BusComponent';
import Popover from "../../popover/Popover";
import FindOpportunitiesItem from "./FindOpportunitiesItem";
import { HelpTourTargets } from '../../../enums/HelpTourDefinitions';

const BREAKPOINT_CONTAINER = 950;

class FindOpportunitiesButton extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.popoverRef = null;
        this.setPopoverRef = element => {
            this.popoverRef = element;
        };
        this.state = {
            isButtonBreakPointReached: false
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleResize = this.handleResize.bind(this);
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        window.addEventListener('resize', this.handleResize);
    };

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener('resize', this.handleResize);
    };

    handleResize() {
        if (window.innerWidth < BREAKPOINT_CONTAINER) {
            this.setState({ isButtonBreakPointReached: true });
        } else {
            this.setState({ isButtonBreakPointReached: false });
        }
    };

    handleClickOutside(event) {
        const { isPopoverVisible, togglePopover } = this.props;

        if (isPopoverVisible && this.popoverRef && !this.popoverRef.contains(event.target)) {
            togglePopover();
        }
    };

    renderPopoverContent = () => {
        const { intl, onFindAreasClick, onFindFacilitiesClick } = this.props;

        const popoverHeader = (
            <span className='find-opportunities__popover__header'>
                {intl.formatMessage({
                    id: 'header.findNewOpportunities'
                })}
            </span>
        );

        const findAreasByCriteria = (
            <FindOpportunitiesItem
                imgSrc={`${AppConfig.constants.assetsBaseURL}/svg/find-areas.svg`}
                titleId="header.findAreasByCriteria"
                subtitleId="header.identifyLocationsBasedOnCriteriaYouSpecify"
                onClick={onFindAreasClick}
            />
        );

        const findFacilities = (
            <FindOpportunitiesItem
                imgSrc={`${AppConfig.constants.assetsBaseURL}/svg/find-facilities.svg`}
                titleId="header.findFacilities"
                subtitleId="header.findFacilitiesThatMatchSpecificCriteria"
                onClick={onFindFacilitiesClick}
            />
        );

        return (
            <div className="find-opportunities__popover" ref={this.setPopoverRef}>
                {popoverHeader}
                {findAreasByCriteria}
                <div className="find-opportunities__popover__divider" />
                {findFacilities}
            </div>
        );
    };

    render() {
        const { intl, isPopoverVisible, togglePopover } = this.props;
        const { isButtonBreakPointReached } = this.state;

        return (
            <div className="find-opportunities-wrapper" data-tourId={HelpTourTargets.FIND_OPPORTUNITIES}>
                <div
                    className={classNames('find-opportunities__container', {
                        'active': isPopoverVisible,
                        'breakpoint': isButtonBreakPointReached
                    })}                    
                >
                    <button
                        type="button"
                        onClick={togglePopover}
                        ref={e => { this.trigger = e; }}
                    >
                        <div style={{ display: 'flex', width: '100%', justifyContent: isButtonBreakPointReached ? 'center' : 'space-between', alignItems: 'center' }}>
                            <i className="material-icons-outlined"> tune </i>
                            {!isButtonBreakPointReached && (intl.formatMessage({ id: 'header.findOpportunities' }))}
                        </div>
                    </button>
                    <Popover
                        className="find-opportunities__popover-wrapper"
                        open={isPopoverVisible}
                        anchorEl={this.trigger}
                    >
                        {this.renderPopoverContent()}
                    </Popover>
                </div>
            </div>
        );
    }
}

FindOpportunitiesButton.propTypes = {
    onFindAreasClick: PropTypes.func.isRequired,
    onFindFacilitiesClick: PropTypes.func.isRequired,
    togglePopover: PropTypes.func.isRequired,
    isPopoverVisible: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
};

FindOpportunitiesButton.defaultProps = {
    isPopoverVisible: false,
};

export default injectIntl(FindOpportunitiesButton);
